import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Montchant · Elevate Your Experience</p>
        <h1>Discover the Essence of Quality.</h1>
        <p className="lede">
          At Montchant, we bring you a curated selection of premium products designed to enhance your everyday life. Explore our offerings and find what resonates with you.
        </p>
        <div className="cta-row">
          <a href="/products" target="_blank">
            Shop Now
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Unmatched Quality</h2>
          <p>
            Our products are meticulously sourced to ensure you receive only the best. Experience the difference with Montchant.
          </p>
        </article>
        <article>
          <h2>Tailored Selections</h2>
          <p>
            Whether you're looking for everyday essentials or unique finds, our diverse range caters to all tastes and preferences.
          </p>
        </article>
        <article>
          <h2>Seamless Shopping</h2>
          <p>
            Enjoy a smooth and secure shopping experience with our user-friendly platform, designed to make your journey effortless.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;